import { render, staticRenderFns } from "./OrderHistoryDetail.vue?vue&type=template&id=1b27a125&scoped=true&"
import script from "./OrderHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryDetail.vue?vue&type=style&index=0&id=1b27a125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b27a125",
  null
  
)

export default component.exports